import { DialogsUtils } from "@/core/utils/layout/dialogs.utils";
import { NotificacaoDTO } from "@/core/domain/dto/privado/notificacao/notificacao.dto";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class NotificacaoModalService {
    private dialogsUtils = inject(DialogsUtils);
    private isShowModalOpen = false;
    private isDetailModalOpen = false;
    private isVisualizacoesModalOpen = false;

    async openShowAll(): Promise<void> {
        if (this.isShowModalOpen) {
            return;
        }

        try {
            this.isShowModalOpen = true;
            const { ShowNotificacoesModalComponent } = await import(
                "@/components/security/notificacao/show-notificacoes-modal/show-notificacoes-modal.component"
            );
            const modal = await this.dialogsUtils.openDialogModal(
                ShowNotificacoesModalComponent,
                "components.showNotificacoesModal.title",
                "75%",
                null,
                "show-notificacoes-dialog",
            );
            await firstValueFrom(modal.onClose);
        } catch (error) {
            console.error("Erro ao abrir o modal de notificações", error);
        } finally {
            this.isShowModalOpen = false;
        }
    }

    async openDetail(notificacao: NotificacaoDTO): Promise<NotificacaoDTO | undefined> {
        if (this.isDetailModalOpen || !notificacao?.id) {
            return undefined;
        }

        try {
            this.isDetailModalOpen = true;
            const { DetailNotificacaoModalComponent } = await import(
                "@/components/security/notificacao/detail-notificacao-modal/detail-notificacao-modal.component"
            );
            const modal = await this.dialogsUtils.openDialogModal(
                DetailNotificacaoModalComponent,
                "components.detailNotificacaoModal.title",
                "55%",
                { notificacao },
                "detail-notificacao-dialog",
            );
            return await firstValueFrom(modal.onClose);
        } catch (error) {
            console.error("Erro ao abrir o detalhe da notificação", error);
            return undefined;
        } finally {
            this.isDetailModalOpen = false;
        }
    }

    async openVisualizacoes(notificacao: NotificacaoDTO): Promise<void> {
        if (this.isVisualizacoesModalOpen || !notificacao?.id) {
            return;
        }

        try {
            this.isVisualizacoesModalOpen = true;
            const { VisualizaVisualizacoesNotificacaoModalComponent } = await import(
                "@/components/security/notificacao/visualiza-visualizacoes-notificacao-modal/visualiza-visualizacoes-notificacao-modal.component"
            );
            const modal = await this.dialogsUtils.openDialogModal(
                VisualizaVisualizacoesNotificacaoModalComponent,
                "components.visualizaVisualizacoesNotificacaoModal.title",
                "55%",
                { notificacao },
                "visualiza-visualizacoes-notificacao-dialog",
            );
            await firstValueFrom(modal.onClose);
        } catch (error) {
            console.error("Erro ao abrir o modal de visualizações da notificação", error);
        } finally {
            this.isVisualizacoesModalOpen = false;
        }
    }
}
